import { Button } from 'saladsoft-primitive';

import { Row } from 'saladsoft-primitive';
import styled from 'styled-components';
import React from 'react';
import IconButton from 'controls/IconButton';

const ModifyButtons = ({
  type,
  showDelete,
  onCancel,
  onSave,
  onDelete,
}: {
  type: 'create' | 'update' | 'delete';
  showDelete: boolean;
  onCancel: () => void;
  onSave: () => void;
  onDelete: () => void;
}) => {
  return (
    <ButtonGroupWrapper>
      <Row width="100%" justifyContent="space-between" alignItems="center">
        <Row gap={10} marginTop={40} justifyContent="flex-start">
          <Button
            type="outlined"
            onClick={() => {
              onCancel();
            }}
          >
            취소
          </Button>
          <Button
            onClick={() => {
              onSave();
            }}
          >
            {type === 'create' ? '생성하기' : type === 'update' ? '수정하기' : '삭제하기'}
          </Button>
        </Row>
        <>
          {showDelete && (
            <IconButton
              type="delete"
              onClick={() => {
                onDelete();
              }}
            />
          )}
        </>
      </Row>
    </ButtonGroupWrapper>
  );
};

const ButtonGroupWrapper = styled.div``;

export default ModifyButtons;
